import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
	selector: 'app-custom-textarea-with-radio',
	templateUrl: './custom-textarea-with-radio.component.html',
	styleUrls: ['./custom-textarea-with-radio.component.scss']
})
export class CustomTextareaWithRadioComponent implements OnInit {
	@Input() public control: FormControl | AbstractControl = new FormControl('');
	@Input() public inputLabel: string = '';
	@Input() public maxLength: number = 400;
	@Input() public toggleValue: boolean = true;
	@Input() public placeholder: string = 'Enter here...';
	@Input() public helperText: string = 'some text';

	constructor() {}

	ngOnInit(): void {}
	public switchToggled(event: boolean): void {
		if (!event) {
			this.control.disable({ onlySelf: true, emitEvent: true });
		} else {
			this.control.enable({ onlySelf: true, emitEvent: true });
		}
	}
}
